export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '8df0790', dateTime: 1784756484876 };